<template>
<div>
	<wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
    <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
       <Row>
          <FormItem label="名称：" prop="name" class="ivu-col-span-18" >

			<Input v-model="paasFormData.name"
			            clearable ></Input>
		   </FormItem>
       </Row>
       <Row>
          <FormItem label="开始日期：" prop="dateStart" class="ivu-col-span-12" >

			<DatePicker type="date" format="yyyy-MM-dd"
			                        v-model="paasFormData.dateStart"
			                        confirm clearable></DatePicker >
		   </FormItem>
           <FormItem label="结束日期：" prop="dateEnd" class="ivu-col-span-12" >

               <DatePicker type="date" format="yyyy-MM-dd"
                           v-model="paasFormData.dateEnd"
                           confirm clearable></DatePicker >
           </FormItem>
       </Row>

       <div class="edit-oper-toolbar">
	      <Button type="primary" @click="paasFormSubmit('paasForm','','productAdd')">保存并添加宝贝</Button>
	      <Button @click="paasFormSubmit('paasForm','','ebDiscountList')" style="margin-left: 8px">保存并返回</Button>
	      <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
	    </div>
    </Form>

    </wrapper-edit>
</div>
</template>
<script>
import wrapperEdit from "@/components/paas/wrapper-edit";
import metaEdit from "@/assets/js/meta-edit.js";

export default {
   name: "edit",
   mixins:[metaEdit],
   components:{wrapperEdit},
   data(){
     return {
     	serviceUrl:"/eb/store/product/discount",  //每个页面访问后台服务器的路径
      	currentIdFiledName: 'id',
        paasFormData:{
        	id:'',
        	name:'',
        	createTime:'',
        	updateTime:'',
        	createUserId:'',
        	createUserName:'',
        	isDelete:'',
        	dateStart:'',
        	dateEnd:'',
        },
        paasFormRules:{
        },
		redirectName:"ebDiscountList",
        nextAddName:"ebDiscountEdit", //保存后跳转页面添加参加本活动的宝贝
     }
   },
   methods:{
       paasFormRouterPush(res,type){
           //;
           let redirectPath = this.redirectName;
           if(type==='add'){
               redirectPath = this.nextAddName;
               this.$emit('getKeyChange',new Date().getTime());
           }else if(type === "productAdd"){
               redirectPath = "ebDiscountProductAdd";
               this.$emit('getKeyChange',new Date().getTime());
           }
           if(this.keepAliveName && typeof(this.keepAliveName) !== "undefined"){
               redirectPath = this.keepAliveName;
           }

           this.$router.push({
               name:redirectPath,
               params: {
                   updateData: [res.data.entity]
               },
               query: {
                   paasCurrentFunctionId: this.$route.query[this.$store.state.funcIdName]
               },
           })
       }
   }
}
</script>
